<template>
  <v-container>
    <p class="text-h1">Here is home</p>
  </v-container>
</template>

<script>
export default {
  name: "RetailMain",

  data: () => ({}),
};
</script>
